module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CKNOWLEDGMENTS")])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("W")]), _vm._v("e owe thanks to many people in helping us put this book together. We thank our families—Walter’s wife Chaya and their children Ari and Kate; Judy and Steven; and Mark and Miriam (who spent a summer helping with the research for this book); Richard, June, Edward, and Amy Kraus; and Paula Chaiken—for their understanding and patience as we fought with each other every step of the way. We thank Charles Bernstein, Irwin Suloway, and Norman Schwartz of the Chicago Jewish Historical Society for their help and encouragement; Joseph “Andy” Hays for his assistance; and Alex Bogdanovitch, Bill Huston, and Ray Marx for their support. We also thank Terri Boekhoff and the people of Rudi Publishing—Michael Huston, Kristin Boekhoff, Brien Woods, and David Featherstone—for their belief in this project and their many efforts to strengthen our manuscript. Finally, we acknowledge the invaluable assistance of Dr. Zanville Klein for his Yiddish translations, and we hope that this book can serve as a testament to his memory.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81f91340","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005_Acknowledgments.vue
// module id = 72
// module chunks = 0